
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOpenSea as ObiOpenSeaElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-open-sea.js';
 
 
 

 
 export const ObiOpenSea = createComponent({
   react: React,
   tagName: 'obi-open-sea',
   elementClass: ObiOpenSeaElement,
   events: {
     
   }
  });
 
 